import React from 'react';
import PropTypes from 'prop-types';

import RecaptchaAttribution from '../RecaptchaAttribution/RecaptchaAttribution';
import * as styles from './HubspotEmbeddedForm.module.scss';

import { loadHubspotFormsScript, waitForThen } from '../../../helpers/helpers';

const HubspotEmbeddedForm = ({ hubspotFormId }) => {
  // Unique per form: two embeds can share a page, and a fixed id would collide.
  const targetId = `hubspotEmbeddedForm-${hubspotFormId}`;

  const embedHubspotForm = () => {
    // the hbspt form should be available on the window object due to
    // the script tag that is run on load of the page in the useEffect
    window.hbspt.forms.create({
      region: process.env.GATSBY_HUBSPOT_REGION,
      portalId: process.env.GATSBY_HUBSPOT_ACCOUNT_ID,
      formId: hubspotFormId,
      target: `#${targetId}`,
    });
  };

  React.useEffect(() => {
    if (!window) return;
    loadHubspotFormsScript();
    waitForThen(() => (window.hbspt !== undefined), embedHubspotForm);
  }, [hubspotFormId]);

  return (
    <>
      <div
        id={targetId}
        className={styles.hubspotEmbeddedForm}
      />
      <RecaptchaAttribution />
    </>
  );
};

HubspotEmbeddedForm.propTypes = {
  hubspotFormId: PropTypes.string.isRequired,
};

export default HubspotEmbeddedForm;
